import {GetHomeMatchPreleadListDto} from "../types/GetHomeMatchPreleadListDto";

export interface IGetHomeMatchPreleadListParams {
    allowResultsMerge?: boolean;
    status?: number;
}

export const serializeHomeMatchPreleadListQueryArgs = (queryArgs: IGetHomeMatchPreleadListParams | void) => {
    if (queryArgs == null) return {};

    const {allowResultsMerge: _allowResultsMerge, ...serializedArgs} = queryArgs;

    return serializedArgs;
};

export const shouldReplaceHomeMatchPreleadList = (arg: IGetHomeMatchPreleadListParams | void) => arg?.allowResultsMerge === false;

export const mergeHomeMatchPreleadList = (
    currentCache: GetHomeMatchPreleadListDto,
    newItems: GetHomeMatchPreleadListDto,
    arg: IGetHomeMatchPreleadListParams | void
) => {
    if (shouldReplaceHomeMatchPreleadList(arg)) {
        currentCache.count = newItems.count;
        currentCache.next = newItems.next;
        currentCache.prev = newItems.prev;
        currentCache.results = [...newItems.results];
        return;
    }

    const uniqItems = newItems.results.filter((element) => !currentCache.results.some((existing) => existing.id === element.id));

    currentCache.results.push(...uniqItems);
};
import {GetHomeMatchPreleadListDto} from "../types/GetHomeMatchPreleadListDto";

export interface IGetHomeMatchPreleadListParams {
    allowResultsMerge?: boolean;
    status?: number;
}

export const serializeHomeMatchPreleadListQueryArgs = (queryArgs: IGetHomeMatchPreleadListParams | void) => {
    if (queryArgs == null) return {};

    const {allowResultsMerge: _allowResultsMerge, ...serializedArgs} = queryArgs;

    return serializedArgs;
};

export const shouldReplaceHomeMatchPreleadList = (arg: IGetHomeMatchPreleadListParams | void) => arg?.allowResultsMerge === false;

export const mergeHomeMatchPreleadList = (
    currentCache: GetHomeMatchPreleadListDto,
    newItems: GetHomeMatchPreleadListDto,
    arg: IGetHomeMatchPreleadListParams | void
) => {
    if (shouldReplaceHomeMatchPreleadList(arg)) {
        currentCache.count = newItems.count;
        currentCache.next = newItems.next;
        currentCache.prev = newItems.prev;
        currentCache.results = [...newItems.results];
        return;
    }

    const uniqItems = newItems.results.filter((element) => !currentCache.results.some((existing) => existing.id === element.id));

    currentCache.results.push(...uniqItems);
};
